module.exports = __webpack_public_path__ + "static/media/hot71.2da08e81.jpg";